import ManagerComplaint from './ManagerComplaint.container';

export default ManagerComplaint;
